import React from 'react';
import { SchoolIcon, WorkReverseIcon } from '../icons';
import { isEmpty } from 'lodash';
import styled from '@mui/material/styles/styled';
import Box from '../Box';
import { DescTetx } from '.';
var eduExperienceKeyArr = ['school', 'major', 'eduBackground', 'eduDate'];
var workExperienceKeyArr = ['companyName', 'positionName', 'workDate'];
var ExperienceRoot = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '8px'
});
/**
 * @description: 处理对象 按照固定的顺序返回
 * @return {Array}
 * @param {*} obj 处理的对象
 * @param {*} keyArr 返回的数组的顺序（规则）
 */
var sortArr = function (obj, keyArr) {
    return keyArr.map(function (n) { return ({ key: n, value: obj[n] }); }).filter(function (t) { return t.value; });
};
export var EduExperience = function (_a) {
    var data = _a.data;
    if (isEmpty(data))
        return null;
    var dataArr = sortArr(data, eduExperienceKeyArr);
    var content = dataArr.map(function (n, i) {
        if (n.key === 'eduDate') {
            var _a = n.value, start = _a.start, end = _a.end;
            return React.createElement(DescTetx, null,
                " ",
                start,
                "\u81F3",
                end,
                " ");
        }
        return React.createElement(DescTetx, null,
            " ",
            n.value,
            " ",
            i !== dataArr.length - 1 && '｜',
            " ");
    });
    return (React.createElement(ExperienceRoot, null,
        React.createElement(SchoolIcon, { style: { marginRight: '12px', fontSize: '20px', color: '#9E9E9E' } }),
        content));
};
export var WorkExperience = function (_a) {
    var data = _a.data;
    if (isEmpty(data))
        return null;
    var dataArr = sortArr(data, workExperienceKeyArr);
    var content = dataArr.map(function (n, i) {
        if (n.value === 'workDate') {
            var _a = n.value, start = _a.start, end = _a.end;
            return React.createElement(DescTetx, null,
                " ",
                start,
                "\u81F3",
                end,
                " ");
        }
        return React.createElement(DescTetx, null,
            " ",
            n.value,
            " ",
            i !== dataArr.length - 1 && '｜',
            " ");
    });
    return (React.createElement(ExperienceRoot, null,
        React.createElement(WorkReverseIcon, { style: { marginRight: '12px', color: '#9E9E9E', fontSize: '20px' } }),
        content));
};
